import {SelectOption} from "@vpfa/ui-kit";
import {isNil} from "lodash";

export function optionValueToName(optionValue: any, options: SelectOption[]) {
  const selectOption = options.find(option => option.value === optionValue);
  return !isNil(selectOption) ? selectOption.name : null;
}
